/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from "react";
import "./styles.scss";

const lock = require("../../assets/img/lock.svg").default;

/**
 * 親でposition: relative;を指定してください。
 * 指定がないと画面外とか変なところに行きます。
 **/
const PrivateMark = () => {
    return (
        <div className="lock">
            <img src={lock} />
            <span>非公開</span>
        </div>
    );
};

export default PrivateMark;
